import { Component, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { UserPermission } from 'src/app/enums/enums';
import { PermissionService } from 'src/app/services/app/permission-access-service/permissionBased.service';
import { ConfigurationService } from 'src/app/services/core/configuration/configuration.service';
import { LosService } from 'src/app/services/core/levelOfService/los.service';
import { NUMBER_OF_RECORDS } from 'src/app/utils/common.utils';
@UntilDestroy()

@Component({
  selector: 'app-levelofservice-list',
  templateUrl: './levelofservice-list.component.html',
  styleUrls: ['./levelofservice-list.component.css']
})
export class LevelofserviceListComponent implements OnInit {
  levelofservices: any;
  filteredLosServices: any = [];
  selectedStatus = '';
  currentPage: number = 1;
  totalPages = 0;
  totalResults = 0;
  search:any;
  status = true
  numberOfRecords = NUMBER_OF_RECORDS
  userPermission=UserPermission;
  losModalObj:any;
  constructor(
    private levelOfService: LosService,
    public permissionService: PermissionService
  ) { }
  ngOnInit() {
    this.getLevelOfService(this.currentPage)
  }

  getLevelOfService(page: number) {
    const queryparams = {
      limit: 50,
      page,
      isActive: this.status
    }
    this.levelOfService.get(queryparams)
      .pipe(untilDestroyed(this)).subscribe((data: any) => {
        if (data && data.results ) {
          this.levelofservices = data.results;
          this.levelofservices = data.results.sort((a: any, b: any) =>
            new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
          );
          this.filteredLosServices = [...this.levelofservices];
          this.totalPages = data.totalPages;
          this.totalResults = data.totalResults;
        }
      })
  }

  filterLosList() {
    this.getLevelOfService(this.currentPage)
  }

  onPageChange(page: number) {
    this.currentPage = page;
    this.getLevelOfService(page);
  }

  onSelectStatus(event: any): void {
   this.status = event.target.value === 'true';
    this.getLevelOfService(this.currentPage = 1)
  }


  openLosModal(los: any) {
    this.losModalObj = los;
  }

  onSaveLos(evt: any) {
    if (evt) {
      const idx = this.filteredLosServices.findIndex((fs: any) => fs.id === evt.id);
      if (this.status === evt.isActive) {
        this.filteredLosServices[idx] = evt;
      } else {
        this.filteredLosServices.splice(idx, 1);
      }
    }
    this.losModalObj = null;
  }

  onCloseLosModal() {
    this.losModalObj = null;
  }


}
